// extracted by mini-css-extract-plugin
export default {"wrap":"Withdraw_wrap__V+oVG","label":"Withdraw_label__zK1Av","value":"Withdraw_value__gkLZk"};